<template>
  <ion-page>
    <ion-header class="ion-no-border" translucent>
      <ion-toolbar class="-not-fixed">
        <!-- <ion-buttons slot="start">
          <ion-back-button
            :defaultHref="{ name: 'roodie-safe' }"
            :icon="require('@lib/assets/icons/icon_zurueck.svg')"
            text="">
          </ion-back-button>
        </ion-buttons> -->
        <ion-title>Befunde & Co</ion-title>
        <ion-button
          @click="modalController.dismiss()"
          slot="end"
          fill="clear"
          size="large"
          ><ion-icon slot="icon-only" :src="close" size="large"></ion-icon
        ></ion-button>
      </ion-toolbar>
      <ion-toolbar class="-not-fixed">
        <ion-segment v-model="selectedSegment">
          <ion-segment-button value="own">
            <ion-label>Eigene</ion-label>
          </ion-segment-button>
          <ion-segment-button value="partner">
            <ion-label>Partner</ion-label>
          </ion-segment-button>
        </ion-segment>
      </ion-toolbar>
    </ion-header>
    <ion-content fullscreen class="ion-padding">
      <ion-grid>
        <template v-if="selectedSegment === 'own'">
          <!-- <h1>Befunde & Co</h1> -->
          <p v-if="!$store.state.showLoading && files.length === 0">
            Sie haben aktuell noch keine Dokumente hochgeladen.
          </p>
          <template v-else>
            <ion-searchbar
              placeholder="Dokumente finden"
              v-model="fileSearch"
            ></ion-searchbar>
            <p v-if="filteredFiles.length === 0">
              Keine Dokumente gefunden. Bitte versuchen Sie einen anderen
              Suchbegriff.
            </p>
            <ion-list>
              <ion-item
                v-for="(file, fileIndex) in filteredFiles.slice().reverse()"
                :key="fileIndex"
                class="gtm-download-file"
              >
                <ion-checkbox
                  slot="start"
                  v-model="selectedUserFiles[file.Id]"
                ></ion-checkbox>
                <div class="ion-text-wrap" style="width: 100%; margin: 10px 0">
                  <ion-row class="ion-align-items-center">
                    <ion-col>
                      <!-- <h2> -->
                      <b>{{
                        DateFormatter.formatDate(
                          new Date(file.Date),
                          "DD. MMMM YYYY HH:mm"
                        )
                      }}</b>
                      <!-- </h2> -->
                    </ion-col>
                    <ion-col size="auto" class="ion-no-padding">
                      <!-- <ion-button
                        fill="clear"
                        @click.stop="
                          openRenameFileModal = true;
                          renameFileId = file.Id;
                          fileName = file.Name;
                        "
                        class="ion-no-margin"
                        ><ion-icon :icon="pencilOutline" slot="icon-only"
                      /></ion-button>
                      <ion-button
                        v-if="showShareFile"
                        fill="clear"
                        @click.stop="shareFile(file.Id)"
                        class="ion-no-margin"
                        ><ion-icon :icon="shareSocialOutline" slot="icon-only"
                      /></ion-button> -->
                      <ion-button
                        fill="clear"
                        @click.stop="
                          downloadFile(file.Id, file.Name, file.MimeType)
                        "
                        class="ion-no-margin"
                        ><ion-icon :icon="eyeOutline" slot="icon-only"
                      /></ion-button>
                      <!-- <ion-button
                        fill="clear"
                        @click.stop="openDeleteFileModal(file.Id)"
                        class="ion-no-margin"
                        ><ion-icon
                          slot="icon-only"
                          :icon="trashOutline"></ion-icon>
                      </ion-button> -->
                    </ion-col>
                  </ion-row>
                  <div>{{ file.Name }}</div>
                  <div
                    v-if="file.Notes?.Partner"
                    style="
                      line-height: normal;
                      font-size: small;
                      margin-top: 10px;
                    "
                  >
                    Geteilt mit {{ file.Notes?.Partner }}
                  </div>
                </div>
              </ion-item>
            </ion-list>
          </template>
        </template>
        <template v-else-if="selectedSegment === 'partner'">
          <ion-searchbar
            placeholder="Dokumente finden"
            v-model="fileSearch"
          ></ion-searchbar>
          <p v-if="filteredFiles.length === 0">
            Keine Dokumente gefunden. Bitte versuchen Sie einen anderen
            Suchbegriff.
          </p>
          <ion-list>
            <ion-item
              v-for="(file, fileIndex) in filteredConversationFiles
                .slice()
                .reverse()"
              :key="fileIndex"
              class="gtm-download-file"
            >
              <ion-checkbox
                slot="start"
                v-model="selectedPartnerFiles[file.Id]"
              ></ion-checkbox>
              <ion-label class="ion-text-wrap">
                <ion-row class="ion-align-items-center">
                  <ion-col>
                    <!-- <h2> -->
                    <b>{{
                      DateFormatter.formatDate(
                        new Date(file.Date),
                        "DD. MMMM YYYY HH:mm"
                      )
                    }}</b>
                    <!-- </h2> -->
                  </ion-col>
                  <ion-col size="auto" class="ion-no-padding">
                    <ion-button
                      fill="clear"
                      @click.stop="
                        downloadFile(file.Id, file.Name, file.MimeType)
                      "
                      class="ion-no-margin"
                      ><ion-icon :icon="eyeOutline" slot="icon-only"
                    /></ion-button>
                  </ion-col>
                </ion-row>
                <h3>{{ file.Name }}</h3>
                <p
                  style="
                    line-height: normal;
                    font-size: small;
                    margin-top: 10px;
                  "
                >
                  Geteilt von {{ file.Notes?.Partner }}
                </p>
              </ion-label>
            </ion-item>
          </ion-list>
        </template>
      </ion-grid>
      <template v-if="selectedSegment === 'own'">
        <add-fab :hideAddDoctor="true" :listFiles="listFiles"></add-fab>
      </template>
    </ion-content>
    <!-- <ion-modal
      :is-open="openRenameFileModal"
      :css-class="['c-autoheight-modal']"
      @didDismiss="openRenameFileModal = false">
      <ion-page>
        <div class="ion-padding modal-content ion-text-center">
          <modal-close />
          <roodie fillOuter="#5E58BE" :expression="'happy'" />
          <h6>Namen ändern</h6>
          <div class="ion-margin-vertical">
            <ion-input v-model="fileName" type="text"></ion-input>
          </div>
          <ion-button @click="renameFile()">Speichern</ion-button>
        </div>
      </ion-page>
    </ion-modal> -->
    <ion-footer>
      <ion-toolbar>
        <ion-button
          expand="block"
          :disabled="
            selectedUserFilesArray.length === 0 &&
            selectedPartnerFilesArray.length === 0
          "
          @click="
            modalController.dismiss({
              userFiles: selectedUserFilesArray,
              partnerFiles: selectedPartnerFilesArray,
            })
          "
        >
          Übernehmen</ion-button
        >
      </ion-toolbar>
    </ion-footer>
  </ion-page>
</template>

<script>
import {
  IonPage,
  IonHeader,
  IonToolbar,
  // IonTitle,
  IonButtons,
  IonContent,
  IonList,
  // IonListHeader,
  IonItem,
  IonLabel,
  // IonNote,
  IonButton,
  IonIcon,
  //   IonText,
  IonGrid,
  IonRow,
  IonCol,
  modalController,
  IonModal,
  IonInput,
  IonSearchbar,
  IonTitle,
  IonSegment,
  IonSegmentButton,
  IonBackButton,
  onIonViewWillEnter,
  IonCheckbox,
  IonFooter,
} from "@ionic/vue";
import {
  chevronBack,
  trashOutline,
  shareSocialOutline,
  pencilOutline,
  cloudDownloadOutline,
  close,
  eyeOutline,
} from "ionicons/icons";
import axios from "@/plugins/axios";
import { DateFormatter } from "@/utils/basics/date";
import AlertModal from "@/components/AlertModal";
import { Share } from "@capacitor/share";
import Roodie from "@lib/components/svg/Roodie";
import ModalClose from "@lib/components/ModalClose";
import { apiListFiles } from "@/api/file";
import { file } from "@/mixins/file";
import { useMessage } from "@/composables/useMessage";
import AddFab from "./AddFab.vue";

export default {
  mixins: [file],
  components: {
    IonPage,
    IonHeader,
    IonToolbar,
    // IonTitle,
    IonButtons,
    IonContent,
    IonList,
    // IonListHeader,
    IonItem,
    IonLabel,
    // IonNote,
    IonButton,
    IonIcon,
    // IonText,
    IonGrid,
    IonRow,
    IonCol,
    IonModal,
    IonInput,
    Roodie,
    ModalClose,
    IonSearchbar,
    IonTitle,
    IonSegment,
    IonSegmentButton,
    IonBackButton,
    IonCheckbox,
    IonFooter,
    AddFab,
  },
  props: {
    userFiles: {
      required: true,
      type: Array,
    },
    partnerFiles: {
      required: true,
      type: Array,
    },
  },
  data() {
    return {
      DateFormatter: DateFormatter,
      //   showShareFile: false,
      //   openRenameFileModal: false,
      //   renameFileId: "",
      //   fileName: "",
      fileSearch: "",
      selectedSegment: "own",
      selectedUserFiles: {},
      selectedPartnerFiles: {},
    };
  },
  created() {
    this.listFiles();
    for (const userFileId of this.userFiles) {
      this.selectedUserFiles[userFileId] = true;
    }
    for (const partnerCaseMessageId of this.partnerFiles) {
      this.selectedPartnerFiles[partnerCaseMessageId] = true;
    }
    // Share.canShare().then(({ value }) => {
    //   if (value) {
    //     this.showShareFile = true;
    //   }
    // });
  },
  computed: {
    selectedUserFilesArray() {
      const result = [];
      for (const [fileId, isSelected] of Object.entries(
        this.selectedUserFiles
      )) {
        if (isSelected) {
          result.push(fileId);
        }
      }
      return result;
    },
    selectedPartnerFilesArray() {
      const result = [];
      for (const [caseMessageId, isSelected] of Object.entries(
        this.selectedPartnerFiles
      )) {
        if (isSelected) {
          result.push(caseMessageId);
        }
      }
      return result;
    },
    files() {
      return this.$store.state.files;
    },
    filteredFiles() {
      const userFiles = this.files.filter(
        (file) => file.FileFromPartner !== true
      );
      if (!this.fileSearch) {
        return userFiles;
      } else {
        const result = [];
        const fileSearchTerms = this.fileSearch.trim().toLowerCase().split(" ");
        for (const file of userFiles) {
          for (const [termIndex, term] of fileSearchTerms.entries()) {
            if (file.Name.toLowerCase().includes(term)) {
              if (fileSearchTerms.length === termIndex + 1) {
                result.push(file);
              }
            } else {
              break;
            }
          }
        }
        return result;
      }
    },
    filteredConversationFiles() {
      const partnerFiles = this.files.filter(
        (file) => file.FileFromPartner === true
      );
      if (!this.fileSearch) {
        return partnerFiles;
      } else {
        const result = [];
        const fileSearchTerms = this.fileSearch.trim().toLowerCase().split(" ");
        for (const file of partnerFiles) {
          for (const [termIndex, term] of fileSearchTerms.entries()) {
            if (file.Name.toLowerCase().includes(term)) {
              if (fileSearchTerms.length === termIndex + 1) {
                result.push(file);
              }
            } else {
              break;
            }
          }
        }
        return result;
      }
    },
  },
  methods: {
    // async renameFile() {
    //   this.$store.commit("setShowLoading", true);
    //   const response = await axios.post("?Mode=General&Function=RenameFile", {
    //     Id: this.renameFileId,
    //     Name: this.fileName,
    //   });
    //   if (response.data.Status === "Success" && response.data.Result) {
    //     await this.listFiles();
    //     this.renameFileId = "";
    //     this.fileName = "";
    //     this.openRenameFileModal = false;
    //   }
    // },
    // async shareFile(id) {
    //   this.$store.commit("setShowLoading", true);
    //   const response = await axios.post("?Mode=General&Function=ShareFile", {
    //     Id: id,
    //   });
    //   if (response.data.Status === "Success") {
    //     await Share.share({
    //       title: "Roodie Health: Ein Dokument steht für Sie bereit",
    //       text:
    //         "Guten Tag, ich möchte mein Roodie.Dokument mit Ihnen teilen. Bitte geben Sie dazu das folgende Passwort an: \n" +
    //         response.data.Result.Password,
    //       url: response.data.Result.Url,
    //       dialogTitle: "Roodie.Dokument teilen",
    //     });
    //   }
    // },
    async listFiles() {
      this.$store.commit("setShowLoading", true);
      await apiListFiles();
    },
    async openDeleteFileModal(fileId) {
      const modal = await modalController.create({
        component: AlertModal,
        cssClass: "c-autoheight-modal",
        componentProps: {
          message: "Möchten Sie die Datei wirklich löschen?",
          buttons: ["Ja", "Nein"],
        },
      });
      modal.onDidDismiss().then((data) => {
        if (data.data?.button === "Ja") {
          this.deleteFile(fileId);
        }
      });
      return modal.present();
    },
    // async deleteFile(fileId) {
    //   this.$store.commit("setShowLoading", true);
    //   const response = await axios.post("?Mode=General&Function=DeleteFile", {
    //     Id: fileId,
    //   });
    //   if (response.data.Status === "Success" && response.data.Result) {
    //     this.$store.commit(
    //       "setFiles",
    //       this.files.filter((obj) => {
    //         return obj.Id !== fileId;
    //       })
    //     );
    //   }
    // },
  },
  setup() {
    // const { getMessages, getMessageFile } = useMessage();
    // getMessages();
    return {
      chevronBack,
      trashOutline,
      shareSocialOutline,
      pencilOutline,
      // getMessageFile,
      cloudDownloadOutline,
      close,
      modalController,
      eyeOutline,
    };
  },
};
</script>

<style lang="scss" scoped></style>
